// URLs that come from the server or from visitors end up in href/location. A javascript: or
// data: URL there executes on click, so only plain http(s) links are allowed through.
export function safeHttpUrl(value) {
  try {
    const url = new URL(String(value), window.location.origin);
    return url.protocol === 'https:' || url.protocol === 'http:' ? url.href : undefined;
  } catch {
    return undefined;
  }
}
